// extracted by mini-css-extract-plugin
export default {"imgdiv":"_184a3e1adb _8998acbfc2","img":"_881f87152a _74adb7a4ed"};